module.exports = __webpack_public_path__ + "img/25.261245e6.jpg";